import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "input-wr" }
const _hoisted_2 = { class: "dropdown-button input-dropdown" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["house-filter-wrapper", { 'mobile-wrapper': !$setup.isDesktop }])
  }, [
    (!$setup.isDesktop)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "filters-button",
          onClick: $setup.toggleFilters
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "icon-wrapper" }, [
            _createElementVNode("svg", {
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "M5 10H15M2.5 5H17.5M7.5 15H12.5",
                stroke: "currentColor",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ])
          ], -1),
          _createElementVNode("span", null, "Filters", -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["filters-container", { 'show-filters': $setup.showFilters || $setup.isDesktop }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filters, (filter) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "filter-group",
          key: filter.type
        }, [
          _createElementVNode("label", null, _toDisplayString(filter.label), 1),
          _createElementVNode("div", _hoisted_1, [
            _createVNode($setup["DropDown"], null, {
              control: _withCtx(() => [
                _createElementVNode("label", _hoisted_2, _toDisplayString(filter.selection), 1)
              ]),
              dropdown: _withCtx(() => [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.options, (option) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: option,
                      onClick: ($event: any) => ($setup.onSelect(filter.type, option))
                    }, _toDisplayString(option), 9, _hoisted_3))
                  }), 128))
                ])
              ]),
              _: 2
            }, 1024)
          ])
        ]))
      }), 128))
    ], 2)
  ], 2))
}